import { useState } from 'react';
import { faqItems } from '@/mocks/home';

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(null);

  const toggleFaq = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            关于成全影院的常见疑问解答
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((faq) => (
            <div
              key={faq.id}
              className="rounded-lg bg-background-100 border border-background-200 overflow-hidden"
            >
              <button
                onClick={() => toggleFaq(faq.id)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer hover:bg-background-200/50 transition-colors duration-200"
              >
                <h3 className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {faq.question}
                </h3>
                <i
                  className={`text-lg text-foreground-500 transition-transform duration-200 flex-shrink-0 ${
                    openId === faq.id ? 'ri-subtract-line' : 'ri-add-line'
                  }`}
                ></i>
              </button>
              {openId === faq.id && (
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}